import uniAdminApi from "./api";

const dashboardService = {
  getStats: async () => {
    const res = await uniAdminApi.get("/university-admin/dashboard/stats");
    return res.data;
  },
};

export default dashboardService;
